import React from 'react';
import { FaCertificate, FaBriefcase, FaDollarSign } from 'react-icons/fa';
import { PROFESSIONAL_TYPES } from './professionalSignupConstants';

export const SignupStep3Rates = ({
  formData,
  handleChange,
  newCertification,
  setNewCertification,
  addCertification,
  removeCertification,
}) => (
  <div className="space-y-4" data-testid="step-3">
    <div>
      <label className="block text-gray-700 font-medium mb-2">Certifications</label>
      <div className="flex space-x-2 mb-2">
        <div className="relative flex-1">
          <FaCertificate className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            value={newCertification}
            onChange={(e) => setNewCertification(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addCertification())}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
            placeholder="e.g., CFP, CPA, JD"
            data-testid="certification-input"
          />
        </div>
        <button
          type="button"
          onClick={addCertification}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Add
        </button>
      </div>
      <div className="flex flex-wrap gap-2">
        {formData.certifications.map((cert, i) => (
          <span
            key={i}
            className="inline-flex items-center px-3 py-1 bg-amber-100 text-amber-800 rounded-full text-sm"
          >
            {cert}
            <button
              type="button"
              onClick={() => removeCertification(cert)}
              className="ml-2 text-amber-600 hover:text-amber-800"
            >
              &times;
            </button>
          </span>
        ))}
      </div>
    </div>

    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-gray-700 font-medium mb-2">Years of Experience</label>
        <div className="relative">
          <FaBriefcase className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="number"
            name="years_experience"
            value={formData.years_experience}
            onChange={handleChange}
            min="0"
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
            placeholder="10"
            data-testid="years-input"
          />
        </div>
      </div>
      <div>
        <label className="block text-gray-700 font-medium mb-2">Hourly Rate ($)</label>
        <div className="relative">
          <FaDollarSign className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="number"
            name="hourly_rate"
            value={formData.hourly_rate}
            onChange={handleChange}
            min="0"
            step="0.01"
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
            placeholder="150.00"
            data-testid="rate-input"
          />
        </div>
      </div>
    </div>

    <div className="bg-blue-50 rounded-lg p-4">
      <label className="flex items-center cursor-pointer">
        <input
          type="checkbox"
          name="offers_free_consultation"
          checked={formData.offers_free_consultation}
          onChange={handleChange}
          className="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
          data-testid="free-consultation-checkbox"
        />
        <span className="ml-3">
          <span className="font-medium text-gray-800">Offer Free Initial Consultation</span>
          <span className="block text-sm text-gray-600">
            This can help attract new clients and build trust
          </span>
        </span>
      </label>
    </div>

    <div className="bg-gray-50 rounded-lg p-4 mt-6">
      <h3 className="font-medium text-gray-800 mb-3">Profile Summary</h3>
      <div className="space-y-2 text-sm">
        <p><span className="text-gray-500">Name:</span> {formData.name}</p>
        <p><span className="text-gray-500">Type:</span> {PROFESSIONAL_TYPES.find(t => t.value === formData.professional_type)?.label || 'Not selected'}</p>
        <p><span className="text-gray-500">Location:</span> {formData.location || 'Not specified'}</p>
        <p><span className="text-gray-500">Specialties:</span> {formData.specialties.join(', ') || 'None added'}</p>
      </div>
    </div>
  </div>
);
